import { render, staticRenderFns } from "./IcoDocumentContent.vue?vue&type=template&id=5a7030e4"
import script from "./IcoDocumentContent.vue?vue&type=script&lang=js"
export * from "./IcoDocumentContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports